import { render } from "./FooterBottom.vue?vue&type=template&id=f113a91e&scoped=true"
import script from "./FooterBottom.vue?vue&type=script&lang=js"
export * from "./FooterBottom.vue?vue&type=script&lang=js"

import "./FooterBottom.vue?vue&type=style&index=0&id=f113a91e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f113a91e"]])

export default __exports__